<template>
  <b-navbar shadow mobile-burger type="is-dark">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        ✋🏻 About me
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-dropdown label="Plugins">
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'VInfiniteSlidebarComponent' }"
        >
          ✨ v-infinite-slidebar
        </b-navbar-item>
      </b-navbar-dropdown>
    </template>

    <template slot="end">
      <b-navbar-item tag="div"> </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: "NavBar",
};
</script>

<style lang="scss">
.navbar {
  background-color: #344861;
  font-weight: bold;
  color: white;
  height: 50px;
}
.navbar-start {
  color: white;
}
</style>
